export default __webpack_public_path__ + "static/Theinhardt-Regular-subset-6760fda15e81d34630d48d8c59926213.woff";